export function getHasTableCellStatus({ statuses, value }) {
  return Boolean(statuses?.[value]?.text)
}
